import { createReducer, on } from '@ngrx/store';

import * as usersActions from '../actions/users.actions';
import { UsersState } from '../states/users.state';

export const usersReducer = createReducer(
    new UsersState(),
    on(usersActions.loadCustomersSuccessful, (state, { customers }) => ({ ...state, customers })),
);